export default __webpack_public_path__ + "static/related-do-6a86311ddaf798f2b5b8487b249a46ab5567e369cc9ab4b29030b315c8856c81.png";